import { getGoToFairePosCTA } from "./shared";
export var UnlinkingPosIA = function UnlinkingPosIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToFairePosCTA;
        return (_getGoToFairePosCTA = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA === void 0 ? void 0 : _getGoToFairePosCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToFairePosCTA2, _getGoToFairePosCTA2$;
        return (_getGoToFairePosCTA2 = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA2 === void 0 ? void 0 : (_getGoToFairePosCTA2$ = _getGoToFairePosCTA2.getLink) === null || _getGoToFairePosCTA2$ === void 0 ? void 0 : _getGoToFairePosCTA2$.call(_getGoToFairePosCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UNLINKING_POS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION(strictLocalize), TO_RECONNECT_A_DIFFERENT_ACCOUNT(strictLocalize)];
    }
  };
};
var UNLINKING_POS = function UNLINKING_POS(strictLocalize) {
  return strictLocalize({
    id: "asarqc",
    defaultMessage: [{
      "type": 0,
      "value": "Dissocier le TPV"
    }]
  });
};
var TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION = function TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION(strictLocalize) {
  return strictLocalize({
    id: "DsdM7O",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez déconnecter votre intégration de TPV actuelle en cliquant sur l'icône de l'utilisateur dans le coin supérieur droit du portail du commerçant, puis en sélectionnant l'option « Mon TPV [NOM DE L'INTÉGRATION] ». Sur cette page, dans le coin supérieur droit, cliquez sur « Paramètres ». Dans vos paramètres, faites défiler la page vers le bas jusqu'à « Déconnecter le TPV [NOM DE L'INTÉGRATION] »."
    }]
  });
};
var TO_RECONNECT_A_DIFFERENT_ACCOUNT = function TO_RECONNECT_A_DIFFERENT_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "4fMVwv",
    defaultMessage: [{
      "type": 0,
      "value": "Pour vous connecter à un autre compte, actualisez la page et cliquez sur « Se connecter à Square », « Se connecter à Shopify » ou « Se connecter à Clover »."
    }]
  });
};